import Dataimg1 from '../../assets/image/Aboutimg/Interior_dataimg1.png'
import Dataimg2 from '../../assets/image/Aboutimg/Interior_dataimg2.png'
import Dataimg4 from '../../assets/image/Aboutimg/Interior_dataimg4.png'
import Dataimg5 from '../../assets/image/Aboutimg/Interior_dataimg5.png'
import Dataimg6 from '../../assets/image/Aboutimg/Interior_dataimg6.png'
export const data =[
    {
        id:1,
        img:Dataimg1,
        title:"Зона регистрации и приема гостей на первой палубе.",
    },
    {
        id:2,
        img:Dataimg2,
        title:"Офис и переговорная для персонала яхт-клуба и встреч с партнерами клуба."
    },
    {
        id:3,
        img:Dataimg2,
        title:"Закрытое помещение на второй палубе с панорамным остеклением",
        describtion:"Для мероприятий до 15-20 человек."
    },
    {
        id:4,
        img:Dataimg4,
        title:"Зал с панорамными окнами",
        describtion:"Находится на первой палубе, трансформируемый под банкетную/фуршетную или деловую рассадку. Вместимость – 200-300 человек (фуршетная рассадка) и 80 человек (банкетная рассадка)."
    },
    {
        id:5,
        img:Dataimg5,
        title:"Открытая веранда на первой палубе",
        describtion:"Прилегает к зоне бассейна. Вместимость – до 150 человек (фуршетная рассадка) и до 70 человек (банкетная рассадка)."
    },
    {
        id:6,
        img:Dataimg6,
        title:"Открытая терраса на второй палубе.",
        describtion:"Вместимость – до 100 человек (фуршетная рассадка) и до 80 человек (банкетная рассадка)."
    },
]